import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'mentionHighlight', pure: true })
export class MentionHighlightPipe implements PipeTransform {
    constructor() { }

    transform(
        text: string,
        mentionedUsers?: Array<{ nickname: string; id: string }>
    ): SafeHtml {
        if (!text) return '';

        if (mentionedUsers?.length) {
            mentionedUsers.forEach(u => {
                if (u.nickname) {
                    text = text.replace(new RegExp(`@${u.nickname}`, 'g'), `<strong>${u.nickname}</strong>`);
                }
            });

            // const names = Array.from(new Set(
            //     mentionedUsers.map(u => u?.nickname).filter(Boolean)
            // ));
            // if (names.length) {
            //     const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            //     const pattern = new RegExp(`(^|\\s)@(${names.map(escape).join('|')})(?=\\b|$)`, 'g');
            //     text = text.replace(pattern, (_m, p: string, name: string) => `${p}<strong>${name}</strong>`);
            // }
        }
        // Optional fallback to bold any @handle not present in mentionedUsers
        // text = text.replace(/(^|\s)@([a-zA-Z0-9._-]{1,50})/g, (_m, p: string, name: string) => `${p}<strong>${name}</strong>`);
        return text;
    }
}